import { useState } from 'react';
import './App.css';
import Toggle from './toggle';
import { motion } from 'framer-motion';
import { Attention, DataStuff, DiffStuff, DAGStuff, GPT, Intro, TransformerStuff, TheFinalPiece } from './content';


const appthemes = {
  'light' : {
    backgroundColor : 'rgb(255, 255, 255)',
    color : 'rgb(0, 0, 0)',
  },
  'dark' : {
    backgroundColor : 'rgb(0, 0, 0)',
    color : 'rgb(255, 255, 255)',
  },
};

const tbvars = {
  'light' : {
    borderBottom : '1px solid rgb(128, 128, 128)',
    backgroundColor : 'rgb(255, 255, 255)'
  },
  'dark' : {
    borderBottom : '1px solid rgb(128, 128, 128)',
    backgroundColor : 'rgb(0, 0, 0)'
  },
};

function TopBar({ title, handleChange, mode }) {
  return (
    <motion.div 
      className='topbarroot'
      variants={tbvars}
      initial={mode}
      animate={mode}
    >
      <div className='topbarinner'>
        <div className='topbartitle'>
          {title}
        </div>
        <Toggle handleChange={handleChange} val={mode}/>
      </div>
    </motion.div>
  );
}

function App() {

  const [mode, setMode] = useState('light');

  return (
    <motion.div 
      className="AppRoot"
      variants={appthemes}
      initial={mode}
      animate={mode}
    >
      <TopBar handleChange={setMode} title='What is ___?' mode={mode}/>
      <div className='App'>
        <h1>What is AutoDiff? Untangling Automatic Differentiation</h1>
        <Intro />
        <br />
        <br />
        <br />
        <br />
        <DiffStuff mode={mode}/>
        <br />
        <br />
        <br />
        <br />
        <DAGStuff mode={mode}/>
        <br />
        <br />
        <br />
        <br />
        <TheFinalPiece mode={mode}/>
        <br />
        <br />
        <br />
        <br />
        {/* <br />
        <br />
        <DataStuff mode={mode}/>
        <br />
        <br />
        <br />
        <br />
        <Attention mode={mode}/>
        <br />
        <br />
        <br />
        <br />
        <GPT mode={mode}/>
        <br />
        <br />
        <FinishedCode mode={mode}/> */}
      </div>
    </motion.div>
  );
}

export default App;
